import { useState } from "react";
import QRCode from "react-qr-code";
import { MODELS, useModel } from "../../../../../../api";
import Button from "../../../../../../design-system/components/Button/Button.jsx";
import CopyToClipboardButton from "../../../../../../design-system/components/CopyToClipboardButton/CopyToClipboardButton.jsx";
import { ROUTES } from "../../../../../../routes.js";
import Dialog from "../../../../../../design-system/components/Dialog/Dialog.jsx";
import tokens from "../../../../../../design-system/tokens.js";
import { Variants } from "../../../../../../design-system/components/Button/Variants.jsx";
import styles from "./InviteInfoDialog.css.ts";

/**
 * Creates the modal that opens when on the Schüler*innen page, one clicks the "Einladen" button
 * to invite students to a course.
 *
 * @param {number} workshopId
 * @returns {JSX.Element|null}
 */
function InviteInfoDialog({ workshopId }) {
  const studentInvite = useModel(MODELS.WORKSHOP_STUDENT_INVITE(workshopId));
  const [open, setOpen] = useState(false);

  const inviteLink =
    studentInvite &&
    `${window.location.origin}${ROUTES.registerPage.getUrl(
      studentInvite.secret,
    )}`;

  const buttons = [
    <Button
      key={0}
      onClick={() => setOpen(false)}
      type="button"
      variant={Variants.PRIMARY}
    >
      QR-Code Schließen
    </Button>,
  ];

  return (
    <>
      {studentInvite ? (
        <Button
          width="fit-content"
          variant={Variants.PRIMARY}
          onClick={() => setOpen(true)}
        >
          Einladen
        </Button>
      ) : (
        "Kein Einladungslink gefunden. Kontaktiere unseren Support."
      )}

      {studentInvite && (
        <Dialog
          open={open}
          setOpen={setOpen}
          title="Schüler*innen via QR-Code einladen"
          buttons={buttons}
        >
          <div className={styles.dialogContainer}>
            <p>
              Schaue dir die Digital Sparks Lernreise an, bereite alles vor und
              lade sobald du soweit bist, deine Schüler*innen ein!
            </p>
            <div className={styles.qrcode}>
              <QRCode
                value={inviteLink}
                size={256}
                fgColor={tokens.color.neutral.white}
                bgColor={tokens.color.full.gray700}
                level="H"
              />
            </div>
            <CopyToClipboardButton value={inviteLink} />
          </div>
        </Dialog>
      )}
    </>
  );
}

export default InviteInfoDialog;
